import React from "react";
import Navbar from "../components/Navbar";
import Portfolio from "../components/Portfolio";
import Footer from "../components/Footer";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";



function PortfolioPage() {
    return (
<main>
    <Navbar/>
    <Portfolio/>
    <Gallery/>
    <Contact />
    <Footer/>
</main>
);
}

export default PortfolioPage;